export default __webpack_public_path__ + "static/sz_en_6-f48cd34cbc8c44fb2f0b072546a9da2f.mp4";